import { DATABASE_MODE_TYPE_ASI } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/sidebar-recent-items-state/recentItemsTypes.js';
import { allLocalThreadRows } from '#pplx/frontend/apps/ask/local-threads/localThreadRows.js';
const RECENT_THREAD_STATUSES = new Set([
    'pending',
    'blocked',
    'completed',
    'sleeping',
]);
function recentThreadStatus(value) {
    return value != null && RECENT_THREAD_STATUSES.has(value)
        ? value
        : undefined;
}
export function localThreadRowToRecentThread(row) {
    const id = row.context_uuid;
    if (!id) {
        return null;
    }
    return {
        uuid: id,
        context_uuid: id,
        title: row.title ?? '',
        link: `/computer/tasks/${id}`,
        mode_type: DATABASE_MODE_TYPE_ASI,
        variant: 'thread',
        unread: row.unread ?? false,
        updated_at: row.last_query_datetime,
        status: recentThreadStatus(row.thread_status),
    };
}
/**
 * Pure read-time merge of local (on-device) rows into a server recents list,
 * by recency. Server rows never carry local ids, but the `uuid` guard keeps
 * the merge idempotent.
 */
export function mergeLocalRecentThreads(serverItems, localRows) {
    const local = allLocalThreadRows(localRows)
        .map(localThreadRowToRecentThread)
        .filter((row) => row !== null);
    if (local.length === 0) {
        return serverItems;
    }
    const merged = [...serverItems];
    const existingUUIDs = new Set(serverItems.map((item) => item.uuid));
    const existingContextUUIDs = new Set(serverItems.flatMap((item) => (item.context_uuid == null ? [] : [item.context_uuid])));
    for (const row of local) {
        if (existingUUIDs.has(row.uuid) || existingContextUUIDs.has(row.context_uuid ?? '')) {
            continue;
        }
        const index = merged.findIndex((item) => (item.updated_at ?? '') < (row.updated_at ?? ''));
        merged.splice(index === -1 ? merged.length : index, 0, row);
        existingUUIDs.add(row.uuid);
        if (row.context_uuid != null) {
            existingContextUUIDs.add(row.context_uuid);
        }
    }
    return merged;
}
//# sourceMappingURL=mergeLocalRecentThreads.js.map